module.exports = __webpack_public_path__ + "static/media/heading_animation.a12f2423.jpg";